import { createFileRoute } from '@tanstack/react-router';
import EditFieldMapsPage from 'src/Administration/Metadata/MetadataFieldMaps/AddEditFieldMapsPages/EditFieldMapsPage';

export const Route = createFileRoute('/systemadmin/_layout/metadata/field-maps/edit/$id')({
  component: EditFieldMapsPage,
});
